import electrolactivity1 from "../../../assets/CampuLifeImages/electrolactivity1.jpg"
import electrolactivity2 from "../../../assets/CampuLifeImages/electrolactvity2.jpg"
import elctrolactivity3 from "../../../assets/CampuLifeImages/electrolactivity3.jpg"
import electrolactivity4 from "../../../assets/CampuLifeImages/electrolactivity4.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import electrolbanner from "../../../assets/CampuLifeImages/electrolbanner.jpg"

const Electrol = () => {

  
   const data = 
    { 
      name:"electrol",
           hover:"true",
      viewmore:"true",
      viewless:"true",
      pagename: "Electrol Club", 
      title: "Electrol Club Activities",
      contentImg:electrolbanner,
      para:"The Electoral Literacy Club(ELC) aims to educate and empower students about electoral rights and responsibilities. By engaging students through interactive activities and experiences, it seeks to sensitize them to the electoral process, emphasizing the significance of ethical voting.",
      paraobjective:"Core Objectives of the ELC:",
      paratitlecontents:[
        {title:"Promote Electoral Awareness : ",content:"Educate students about  electoral system, voting procedures, and  active participation in democracy."},
        {title:"Encourage Voter Registration : ",content:"Assist eligible students in registering as voters and updating their electoral details."},
        {title:"Foster Ethical Voting : ",content:"Instill the values of free, fair, and informed voting, discouraging malpractices like bribery and coercion."},
        {title:"Enhance Democratic Participation : ",content:"Encourage active citizenship by making elections more accessible and engaging."},
        {title:"Conduct Electoral Activities : ",content:"Organize quizzes, debates, mock elections, and other interactive programs to make learning about elections engaging."},
        {title:"Target First-time Voters : ",content:"Focus on educating first-time and young voters to increase their participation in elections."},
      ],
      paraone:"By achieving these objectives, the ELC at Noorul Islam College of Arts and Science endeavors to cultivate a well-informed and proactive student community that upholds the principles of democracy and contributes positively to the nation's electoral processes.",
      fourhover:true
     }
   
   const hoverContent =[
     {  img: elctrolactivity3, para1: "Voters' Day - Voters' awareness pledge taking @ NICAS", para2: "Jan 25, 2024" },
     {  img: electrolactivity4, para1: "Electrol Club Programme", para2: "March 14, 2024" },
     {  img: electrolactivity1, para1: "Our college students participated in Wall Painting organized by Election Team of K. K Dist., in the Theme of 'Awareness on Hundred percent Voting' to the public at Thuckalay. Various college students and school students participated. Collector Thiru P N. Sreedhar presided over the event and distributed Prizes. Students issued Bit Notice to the public.", para2: "April 01, 2024" },
     {  img: electrolactivity2, para1: "Our college students participated in Wall Painting organized by Election Team of K. K Dist., in the Theme of 'Awareness on Hundred percent Voting' to the public at Thuckalay. Various college students and school students participated. Collector Thiru P N. Sreedhar presided over the event and distributed Prizes. Students issued Bit Notice to the public.", para2: "April 01, 2024"  },
 ]

 const tableData = [
  {title:"Electrol Club Organizers"},
  {headings:[{heading1:"S.No",heading2:"Name",heading3:"Designation & Department",heading4:"Position"}]},
  {data:[{ id: 1, name: 'Mr. V.S Krishna Prasad', designDept:"Assistant Professor, Computer Science" ,pos:"Nodal Officer"},
  { id: 2, name: 'Mr. V. I. Sree Dev', designDept:"Assistant Professor, English" ,pos:"Member" },
 
]},
  {padding:true}
];
  return (
    <>
  
    <ExtenStudClubGrievPage  data = {data} hoverContent = {hoverContent} />
      </>
  )
}

export default Electrol

